import React, { useEffect } from 'react';
import { Checkbox } from 'ui-kit';

import './NotificationChannels.scss';

export interface INotificationChannelsValue {
  is_sms_enabled: boolean;
  is_whatsapp_enabled: boolean;
}

export interface INotificationChannels {
  smsEnabled: boolean;
  whatsappEnabled: boolean;
  onChange: (next: INotificationChannelsValue) => void;
  disabled?: boolean;
  smsSupported?: boolean;
  title?: string;
}

const NotificationChannels = ({
  smsEnabled,
  whatsappEnabled,
  onChange,
  disabled,
  smsSupported = true,
  title = 'Send notifications via:',
}: INotificationChannels) => {
  useEffect(() => {
    if (!smsSupported && smsEnabled) {
      onChange({ is_sms_enabled: false, is_whatsapp_enabled: true });
    }
  }, [smsSupported, smsEnabled]);

  return (
    <div className="NotificationChannels">
      <p className="label-title">{title}</p>
      <Checkbox
        checked={smsEnabled}
        disabled={disabled || !smsSupported}
        onChange={(e) =>
          onChange({ is_sms_enabled: e.target.checked, is_whatsapp_enabled: whatsappEnabled })
        }
      >
        Text message
      </Checkbox>
      <Checkbox
        checked={whatsappEnabled}
        disabled={disabled}
        onChange={(e) =>
          onChange({ is_sms_enabled: smsEnabled, is_whatsapp_enabled: e.target.checked })
        }
      >
        WhatsApp
      </Checkbox>
      {!smsSupported && (
        <p className="channel-hint">Text messages are only available for US and Canada numbers.</p>
      )}
    </div>
  );
};

export default NotificationChannels;
